import { unsubscribeAll } from 'app/shared/flux/actions/MarketingActions';
import { formatForLog } from 'app/shared/utils/errors';

const logger = getLogger('pages/UnsubscribeAllPage');
// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;
  const state = store.getState();
  const query = state.router.location.query;

  const { email, cancelHash } = query;
  return dispatch(unsubscribeAll({ email: decodeURIComponent(email), cancelHash })).catch(
    (error: { message: string; code: string }) => {
      logger.error(formatForLog(error), 'Unsubscribe All Page: Error unsubscribing user.');
    },
  );
};

export default serverRouteWillMount;
